import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import RightCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/RightCircleOutlined";
import AntdIcon from "../components/AntdIcon";
var RightCircleOutlined = function RightCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RightCircleOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  RightCircleOutlined.displayName = 'RightCircleOutlined';
}
export default /*#__PURE__*/React.forwardRef(RightCircleOutlined);